export const SEARCH = '/search';
export const ACTUAL_ENTERPRISES = '/actual-enterprises';
export const ACTUAL_OFFERS = '/actual-offers';
export const SUPPLIER = '/supplier';
export const CLIENT = '/client';
export const ELEVATOR = '/elevator';
export const ADD = '/add';
export const SETTINGS = '/settings';
export const SUPPLIER_DETAIL = '/supplier-detail';
export const CLIENTS_DETAIL = '/client-detail';
export const ELEVATOR_DETAIL = '/elevator-detail';
export const USER_DETAIL = '/user-detail';
export const MANAGE_TASKS = '/manage-users-tasks';



// WEBPACK FOOTER //
// ./constants/routes.js